

/**
 * Writes a message to console.log().
 * @customfunction LOG
 * @param {string} message String to write.
 * @returns String to write.
 */
export function logMessage(message) {
  console.log(message);

  return message;
}

/**
 * Liefert ein beliebiges Feld zu einer ISIN aus fin-api.io (case-insensitive field)
 * @customfunction
 * @param {string} isin
 * @param {string} field
 * @returns {Promise<string>}
 */
export async function FMDBASSETS_MASTER_BY_ISIN(isin, field) {
  if (!isin) return "Missing ISIN";
  if (!field) return "Missing Field";

  const apiKey = localStorage.getItem("donkey_api_key") ?? "";

  if (!apiKey) {
    return "Missing API-Key";
  }

  const response = await fetch(
    `https://donkey-api.staging.finvia.fo/donkey_fmdbassets/get_master_by_isin?isin=${encodeURIComponent(isin)}`,
    {
      method: "GET",
      headers: {
        "Authorization":  `Bearer ${apiKey}`,   
      },
    }
  );

  if (!response.ok) {
    return `API error ${response.status}`;
  }

  const data = await response.json();

  if (!data || Object.keys(data).length === 0) {
    return "Unknown Asset";
  }

  // case-insensitive field lookup
  const fieldLower = field.toLowerCase();
  const matchedKey = Object.keys(data).find((key) => key.toLowerCase() === fieldLower);

  if (!matchedKey) {
    //return "Unknown Field";
    return `Unknown Field. Available: ${Object.keys(data).join(", ")}`;
  }

  return data[matchedKey] ?? "Unknown Field";
}

/**
 * Liefert ein beliebiges Feld zu einer ISIN aus fin-api.io (case-insensitive field)
 * @customfunction
 * @param {string} isin
 * @param {string} mnemonic
 * @param {string} [field] Optional. Standardmäßig wird mnemonic verwendet.
 * @returns {Promise<string>}
 */
export async function FMDBASSETS_FIELD_BY_ISIN_MNEMONIC(isin, mnemonic, field) {
  if (!isin) return "Missing ISIN";
  if (!mnemonic) return "Missing Mnemonic";
  field = field?.trim() || mnemonic;
  if (!field) return "Missing Field";

  const apiKey = localStorage.getItem("donkey_api_key") ?? "";

  if (!apiKey) {
    return "Missing API-Key";
  }

  const response = await fetch(
    `https://donkey-api.staging.finvia.fo/donkey_fmdbassets/get_field_by_isin_and_mnemonic?isin=${encodeURIComponent(isin)}&mnemonic=${encodeURIComponent(mnemonic)}`,
    {
      method: "GET",
      headers: {
        "Authorization":  `Bearer ${apiKey}`,   
      },
    }
  );

  if (!response.ok) {
    return `API error ${response.status}`;
  }

  const data = await response.json();

  if (!data || Object.keys(data).length === 0) {
    return "Unknown Asset";
  }

  // case-insensitive field lookup
  const fieldLower = field.toLowerCase();
  const matchedKey = Object.keys(data).find((key) => key.toLowerCase() === fieldLower);

  if (!matchedKey) {
    //return "Unknown Field";
    return `Unknown Field. Available: ${Object.keys(data).join(", ")}`;
  }

  return data[matchedKey] ?? "Unknown Field";
}










/**
 * Liefert verfügbare FMDB Asset Fields als Matrix via XAPI
 * @customfunction
 * @returns {Promise<any[][]>}
 */
export async function FMDBASSETS_MD_FIELDS() {
  const apiKey = localStorage.getItem("donkey_api_key") ?? "";

  if (!apiKey) {
    return [["Missing API-Key"]];
  }

  const response = await fetch(
    `https://donkey-api.staging.finvia.fo/donkey_fmdbassets/get_md_fields`,
    {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${apiKey}`,       
      },
    }
  );

  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    return [[`API error ${response.status}: ${errorText}`]];
  }

  const data = await response.json();

  if (!Array.isArray(data) || data.length === 0) {
    return [["No fields found"]];
  }

  const columns = [
    "field_mnemonic",
    "field_name",
    "table_name",
    "column_name",
    "field_type",
    "provider",
    "datatype",
    "date_type",
    "instrument_class",
  ];

  const rows = data.map((item) =>
    columns.map((col) => item[col] ?? "")
  );

  return [columns, ...rows];
}
CustomFunctions.associate("LOG", logMessage);
CustomFunctions.associate("FMDBASSETS_MASTER_BY_ISIN", FMDBASSETS_MASTER_BY_ISIN);
CustomFunctions.associate("FMDBASSETS_FIELD_BY_ISIN_MNEMONIC", FMDBASSETS_FIELD_BY_ISIN_MNEMONIC);
CustomFunctions.associate("FMDBASSETS_MD_FIELDS", FMDBASSETS_MD_FIELDS);